import React, {useEffect, useState} from "react";
import axios from "axios";
import "../styles/ExamForm.css";

export default function ExamForm() {
    const [groups, setGroups] = useState([]);
    const [courses, setCourses] = useState([]);
    const [form, setForm] = useState({
        examName: "",
        course: "",
        groupGroup: "",
        questionCount: 0,
        createdAt: new Date().toISOString()
    });

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/question-groups`).then((res) => setGroups(res.data));
        axios.get(`${process.env.REACT_APP_API_URL}/courses`).then((res) => setCourses(res.data));
    }, []);

    const handleChange = (e) => {
        const {name, value} = e.target;
        setForm({...form, [name]: value});
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = {
            examName: form.examName,
            questionCount: parseInt(form.questionCount),
            group: {id: form.groupId},
            course: {id: form.courseId},
            createdAt: form.createdAt
        };

        axios.post(`${process.env.REACT_APP_API_URL}/exams`, payload)
            .then(() => alert("Sınav başarıyla eklendi!"))
            .catch((err) => console.log("Hata: " + err.message));
    };

    return (
        <form onSubmit={handleSubmit} className="exam-form">
            <h2>Yeni Sınav Ekle</h2>
            <label htmlFor="examName">Sınav Adı</label>
            <input type="text" name="examName" value={form.examName} onChange={handleChange} placeholder="Sınav Adı"
                   required/>
            <label htmlFor="questionCount">Soru Sayısı</label>
            <input type="number" name="questionCount" value={form.questionCount} onChange={handleChange}
                   placeholder="Soru Sayısı" required/>
            <label htmlFor="groupId">Soru Grubu</label>
            <select name="groupId" value={form.groupId} onChange={handleChange} required>
                <option value="">Soru Grubu Seçin</option>
                {groups.map((group) => (
                    <option key={group.id} value={group.id}>{group.groupName}</option>
                ))}
            </select>
            <label htmlFor="courseId">Kurs</label>
            <select name="courseId" value={form.courseId} onChange={handleChange} required>
                <option value="">Kurs Seçin</option>
                {courses.map((course) => (
                    <option key={course.id} value={course.id}>{course.name}</option>
                ))}
            </select>
            <button type="submit">Kaydet</button>
        </form>
    );
}

